/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Open_ExerciseInputs */

const en_us2_search_open_exercise = /** @type {(inputs: Search_Open_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open exercise`)
};

const pt_br2_search_open_exercise = /** @type {(inputs: Search_Open_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir exercício`)
};

const es_419_search_open_exercise = /** @type {(inputs: Search_Open_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir ejercicio`)
};

const pt_pt2_search_open_exercise = /** @type {(inputs: Search_Open_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir exercício`)
};

const fr_fr2_search_open_exercise = /** @type {(inputs: Search_Open_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir l'exercice`)
};

const de_de2_search_open_exercise = /** @type {(inputs: Search_Open_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung öffnen`)
};

const it_it2_search_open_exercise = /** @type {(inputs: Search_Open_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri esercizio`)
};

/**
* | output |
* | --- |
* | "Open exercise" |
*
* @param {Search_Open_ExerciseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_open_exercise = /** @type {((inputs?: Search_Open_ExerciseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Open_ExerciseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_open_exercise(inputs)
	if (locale === "es-419") return es_419_search_open_exercise(inputs)
	if (locale === "pt-PT") return pt_pt2_search_open_exercise(inputs)
	if (locale === "fr-FR") return fr_fr2_search_open_exercise(inputs)
	if (locale === "de-DE") return de_de2_search_open_exercise(inputs)
	if (locale === "it-IT") return it_it2_search_open_exercise(inputs)
	return en_us2_search_open_exercise(inputs)
});
export { search_open_exercise as "search.open_exercise" }